import FindMyAwardBreadcrumbs from './FindMyAwardBreadcrumbs'

export const FindMyAwardLayout = ({ children }) => {
  return (
    <div className="content-wrapper landing one-column">
      <FindMyAwardBreadcrumbs />
      <article className="main">{children}</article>
    </div>
  )
}
